// @ts-nocheck
import React from 'react'
import { useSelector } from 'react-redux'
import * as R from 'ramda'

import { Redirect } from 'components/shared/Routes/Redirect/Redirect'

import { getFeatureFlags } from 'ducks/auth'
import { toProjects } from 'ducks/router'

export const FeatureFlag = ({
  action = toProjects,
  children,
  shouldRedirect = false,
  ...restProps
}) => {
  const featureFlags = useSelector(getFeatureFlags)

  const shouldShowChildren = R.whereEq(
    R.dissoc('children', restProps),
    featureFlags,
  )

  // TODO: we could display NotFound page instead and
  // update it with the link to '/'
  if (!R.isEmpty(featureFlags) && !shouldShowChildren && shouldRedirect) {
    console.error(`featureFlag missing: ${JSON.stringify(restProps)}`)
    return <Redirect {...{ action }} />
  }

  return shouldShowChildren ? children : null
}